<template>
  <tr class="calculation-result__row">
    <td class="calculation-result__cell">
      <slot name="description" />
    </td>
    <td class="calculation-result__cell">
      <slot name="value" />
    </td>
  </tr>
</template>

<script>
export default {
  name: "CalculationResultRow"
};
</script>
